'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { ChevronDownIcon, ClockDashedIcon } from '@navikt/aksel-icons';
import { BodyShort, Button, Detail } from '@navikt/ds-react';
import styles from './Historikk.module.css';
import { store } from '@/app/_components/store/store';
import { AnsettelsesDetaljer } from '@/types/arbeidsforhold';
import { formatDatePeriode } from '@/utils/formatting/dato';
import { addTekstAndData } from '@/utils/formatting/tekst';
import classNames from 'classnames';
const ANTALL_ENDRINGER_FOER_VIS_ALLE = 3;

/** Sammenleggbar tidslinje over historiske endringer for ett attributt. */
export default function Historikk(t0) {
  const $ = _c(30);
  const {
    endringer,
    getHistorikk
  } = t0;
  const {
    tekst
  } = store.useReducerState();
  const [apen, setApen] = React.useState(true);
  const [visAlle, setVisAlle] = React.useState(false);
  let t1;
  if ($[0] !== endringer || $[1] !== visAlle) {
    t1 = visAlle ? endringer : endringer.slice(0, ANTALL_ENDRINGER_FOER_VIS_ALLE);
    $[0] = endringer;
    $[1] = visAlle;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const synlige = t1;
  let t2;
  if ($[3] !== endringer.length || $[4] !== tekst.detaljer.antallEndringer || $[5] !== tekst.detaljer.enEndring) {
    t2 = endringer.length === 1 ? tekst.detaljer.enEndring : addTekstAndData(endringer.length, tekst.detaljer.antallEndringer);
    $[3] = endringer.length;
    $[4] = tekst.detaljer.antallEndringer;
    $[5] = tekst.detaljer.enEndring;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const antallTekst = t2;
  let t3;
  if ($[7] !== apen) {
    t3 = () => setApen(!apen);
    $[7] = apen;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ClockDashedIcon aria-hidden={true} fontSize="1.25rem" />;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== antallTekst) {
    t5 = <span>{antallTekst}</span>;
    $[10] = antallTekst;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = apen && styles.chevronApen;
  let t7;
  if ($[12] !== t6) {
    t7 = classNames(styles.chevron, t6);
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <ChevronDownIcon aria-hidden={true} className={t7} fontSize="1.25rem" />;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== apen || $[17] !== t3 || $[18] !== t5 || $[19] !== t8) {
    t9 = <button type="button" className={styles.toggle} aria-expanded={apen} onClick={t3}>{t4}{t5}{t8}</button>;
    $[16] = apen;
    $[17] = t3;
    $[18] = t5;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== apen || $[22] !== endringer.length || $[23] !== getHistorikk || $[24] !== synlige || $[25] !== tekst.detaljer.visAlleEndringer) {
    t10 = apen && <><ul className={styles.liste}>{synlige.map((historikk, index) => <li key={index}><Detail className={styles.periode}>{formatDatePeriode(historikk.rapporteringsmaanedFra, historikk.rapporteringsmaanedTil, "MMM YYYY")}</Detail><BodyShort size="small">{getHistorikk(historikk)}</BodyShort></li>)}</ul>{endringer.length > synlige.length && <Button className={styles.visAlle} variant="tertiary" size="small" onClick={() => setVisAlle(true)}>{addTekstAndData(endringer.length, tekst.detaljer.visAlleEndringer)}</Button>}</>;
    $[21] = apen;
    $[22] = endringer.length;
    $[23] = getHistorikk;
    $[24] = synlige;
    $[25] = tekst.detaljer.visAlleEndringer;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== t9) {
    t11 = <div className={styles.historikk}>{t9}{t10}</div>;
    $[27] = t10;
    $[28] = t9;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  return t11;
}